import { gql } from '@apollo/client';

export const BRANDS_QUERY = gql`
    query brands {
        brands {
            edges {
                node {
                    id
                    name
                    slug
                    segmentId
                    __typename
                }
                __typename
            }
            __typename
        }
    }
`;
